import * as React from 'react';
import { SVGProps } from 'react';

const SvgBrep = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 22H6.565V7.565H21V22Zm1-14.435v-.531a1 1 0 0 0-.36-.769L16.8 2.232A1 1 0 0 0 16.16 2H2a1 1 0 0 0-1 1v14.16a1 1 0 0 0 .232.64l4.033 4.84a1 1 0 0 0 .769.36H21a1 1 0 0 0 1-1V7.565Zm-1.562-1H6.175L2.808 3H16.16l4.278 3.565Zm-14.873.81v14.063L2 17.16V3.6l3.565 3.775Z'
      fill='#000'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.957 10.217a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm-3.653 0a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm8.218-.913a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.739.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm-10.044 2.74a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.74.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm4.565-.913a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.739.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826ZM9.217 16.609a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.74.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm4.565-.913a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.739.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826ZM9.217 20.26a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.74.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Zm4.565-.913a.913.913 0 1 1-1.826 0 .913.913 0 0 1 1.826 0Zm2.739.913a.913.913 0 1 0 0-1.826.913.913 0 0 0 0 1.826Z'
      fill='#000'
    />
  </svg>
);

export default SvgBrep;
